<template>
	<div :class="{active: shopStore.showCart}" class="container-cart" @click.self="shopStore.showCart = false">
		<div class="shop-cart">
			<div class="heading-cart">
				<h3>{{ getString("cart_summary") }}</h3>
			</div>
			<div class="container-input-list">
				<div v-if="shopStore.getTotalItemQuantity() <= 0" class="skeleton-product">
					<img src="https://img.qromo.io/img/product-skeleton.svg" alt="skeleton product">
				</div>
				<ProductCart v-if="shopStore.getTotalItemQuantity() > 0" :item-id="item.id" v-for="item in shopStore.cart" :key="item.id" />
			</div>
			<div class="delivery-content">
				<AppRadioButtonGroup direction="vertical" :values="[getString('standard_delivery_min'), getString('express_delivery_min_cart')]" @radio-chosen="i => selectedShipping = i" />
			</div>
			<div class="total-summary">
				<div class="row-summary">
					<p>{{ getString("subtotal") }}</p>
					<p>{{ currencyStore.readableCurrencyValue(shopStore.getSubtotal(), false)  }}</p>
				</div>
				<div v-if="shopStore.getTotalItemQuantity() > 0" class="row-summary">
					<p>{{ getString("shipping") }}</p>
					<p>{{ currencyStore.readableCurrencyValue(shippingCosts, false) }}</p>
				</div>
				<div class="total-container">
					<div class="total-content">
						<p>{{ getString("total") }}</p>
						<p>{{ currencyStore.readableCurrencyValue(grandTotal, false) }}</p>
					</div>
					<div class="iva-content">
						<p>{{ getString("plus_vat") }}<span v-if="isSplitPayment">*</span></p><p v-if="COUNTRY === 'IT'">{{ currencyStore.readableCurrencyValue(grandTotalWithVAT-grandTotal, false) }}</p>
					</div>
				</div>
				<AppButton :text="getString('proceed_to_payment')" @click="proceedToPayment" :loading="loadingStripe" :disabled="shopStore.cart.length === 0" />
				<div class="align-payments-logo">
					<img src="https://img.qromo.io/img/logo-apple-pay.svg" alt="logo apple pay">
					<img src="https://img.qromo.io/img/logo-google-pay.svg" alt="logo google pay">
					<img src="https://img.qromo.io/img/logo-master-card.svg" alt="logo Mastercard">
					<img src="https://img.qromo.io/img/logo-visa.svg" alt="logo Visa">
					<img src="https://img.qromo.io/img/logo-klarna.svg" alt="logo klarna">
				</div>
				<div class="term-condition-style" v-if="isSplitPayment">
					<p>{{ getString('split_payment_info') }}</p>
				</div>
				<div class="term-condition-style">
					<p>{{ getString('click_to_proceed_to_payment_tc') }} <a :href="URL_HTML+'/terms-of-sale/'">{{ getString('t_and_c') }}</a></p>
				</div>
			</div>
		</div>
		<CheckoutInPlace :client-secret="clientSecret" @toggling-popup="togglingPopupSheet" @checkout-complete="paymentComplete" />
	</div>
</template>

<script>
import {useCurrencyStore, useLanguageStore, useScriptStore} from "@/shared/stores";
import ProductCart from "@/shop/components/ProductCart.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppRadioButtonGroup from "@/shared/components/AppRadioButtonGroup.vue";
import {useShopStore} from "@/shop/stores";
import API from "@/shared/helpers/API";
import {useUserStore} from "@/user/stores";
import CheckoutInPlace from "@/console-new/components/shared/CheckoutInPlace.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const shopStore = useShopStore();
		const scriptStore = useScriptStore();
		const userStore = useUserStore();
		const currencyStore = useCurrencyStore();
		return {currencyStore, languageStore, getString: languageStore.getString, shopStore, loadScript: scriptStore.loadScript, userStore};
	},
	components: {CheckoutInPlace, AppRadioButtonGroup, AppButton, ProductCart},
	name: "CartShop",
	data() {
		return {
			selectedShipping: 0,
			stripe: null,
			loadingStripe: false,
			clientSecret: null,
			URL_HTML: URL_HTML,
		}
	},
	computed: {
		isSplitPayment() {
			return this.userStore?.currBusiness?.split_payment_invoicing;
		},
		grandTotal() {
			if(this.shopStore.getTotalItemQuantity() > 0) {
				return (this.shopStore.getSubtotal()+this.shippingCosts);
			} else {
				return 0;
			}
		},
		grandTotalWithVAT() {
			return this.grandTotal*1.22;
		},
		shippingCosts() {
			let lowCostPrice = this.shopStore.currencyItemPrice({id: "shipping_low"});
			let highCostPrice = this.shopStore.currencyItemPrice({id: "shipping_high"});
			let currMinExpenseForFreeShipping = this.currencyStore.currCurrency?.min_free_shipping_amount || 0;
			let baseCost = 0;
			if(this.selectedShipping === 1) {
				baseCost = this.shopStore.getSubtotal() >= currMinExpenseForFreeShipping ? lowCostPrice : highCostPrice;
			} else {
				baseCost = this.shopStore.getSubtotal() >= currMinExpenseForFreeShipping ? 0 : lowCostPrice;
			}
			return baseCost;
		}
	},
	methods: {
		togglingPopupSheet(v) {
			if(!v) {
				this.clientSecret = null;
			}
		},
		paymentComplete() {
			setTimeout(() => {
				this.clientSecret = null;
				this.shopStore.cart = [];
				this.shopStore.showCart = false;
			}, 2500);
		},
		proceedToPayment() {
			let products = this.shopStore.cart.map(p => {
				let item = this.shopStore.getItemById(p.id);
				return {
					id: this.currencyStore.priceFromId(item.id),
					keyid: item.id,
					quantity: p.quantity
				}
			});

			if(this.shippingCosts) {
				let finalPrice = this.shopStore.currencyItemPrice({id: "shipping_low"});
				let costName = this.shippingCosts === finalPrice ? 'low' : 'high';
				let shippingPrice = this.currencyStore.priceFromId("shipping_"+costName);

				if(shippingPrice) {
					products.push({
						id: shippingPrice,
						keyid: "shipping_"+costName,
						quantity: 1
					})
				}
			}

			if(products.length === 0) {
				return;
			}

			this.loadingStripe = true;

			let consoleUrl = URL_HTML + '/console/new';
			let successUrl = URL_HTML + '/console/new/params.php?url=' + encodeURIComponent(consoleUrl + '/plugins/shop') + "&message=shop_success";
			let failUrl = URL_HTML + '/console/new/params.php?url=' + encodeURIComponent(consoleUrl + '/plugins/shop') + "&message=shop_fail";

			API.init().checkoutProducts(products, this.userStore.user.stripe_customer, this.userStore.currBusinessId,  successUrl,  failUrl, (r) => {
				this.loadingStripe = false
				if(r && r.result && r.result === "OK" && r.checkout) {
					this.clientSecret = r.checkout;
				}
			});
		},
	},
	watch: {
		'shopStore.autoCheckout': function(newVal) {
			if (newVal === true) {
				// Small delay to ensure cart is fully rendered
				setTimeout(() => {
					this.proceedToPayment();
					// Reset the flag
					this.shopStore.autoCheckout = false;
				}, 500);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.container-cart {
	padding: 20px 40px;
	position: sticky;
	top: 0;
	height: 100%;
	@media (max-width: 1560px) {
		padding: 20px;
	}
	@media (max-width: 1440px) {
		position: absolute;
		z-index: 9;
		right: 0;
		width: 100%;
		background-color: rgb(0 0 0 / 0);
		visibility: hidden;
		transition: background-color .2s $transition;
		height: 100%;
	}
	@media (max-height: 700px) {
		overflow-y: auto;
	}
	@media(max-width: 520px) {
		width: 100%;
		padding: 10px 10px 10px 20px;
	}

	.shop-cart {
		box-shadow: 0 3px 5px var(--color-box-shadow-3);
		border-radius: 13px;
		background-color: var(--color-bg);
		width: 100%;
		max-width: 380px;
		min-width: 320px;
		height: 100%;
		max-height: 850px;
		display: flex;
		flex-direction: column;
		@media(max-width: 1440px) {
			position: sticky;
			transform: translateX(25px);
			transition: transform .3s $transition, opacity .3s $transition;
			opacity: 0;
			width: 380px;
			margin-left: auto;
		}
		@media (max-height: 700px) and (max-width: 1440px) {
			margin-bottom: 60px;
		}
		@media (max-width: 768px) {
			height: calc(100% - 50px);
			position: relative;
		}
		@media (max-height: 700px) {
			height: auto;
			position: relative;
		}
		@media(max-width: 520px) {
			width: 100%;
		}
		@media(max-width: 350px) {
			min-width: unset;
		}
		.skeleton-product {
			opacity: 0.5;
			img {
				object-fit: contain;
				width: 100%;
				height: auto;
			}
		}
		.heading-cart {
			display: flex;
			height: 49px;
			background-color: var(--color-bg-primary-2);
			border-radius: 13px 13px 0 0;
			align-items: center;
			padding: 0 15px;
			h3 {
				font-size: 18px;
				color: var(--color-txt);
				padding: 14px 0;
			}
		}
		.delivery-content {
			padding: 8px 0;
			margin: 0 15px 15px;
			border-top: 1px solid var(--color-border-alpha);
			border-bottom: 1px solid var(--color-border-alpha);
			:deep(.radio-group) {
				width: 100%;
				.radio-buttons {
					margin-bottom: 8px;
					&:last-child {
						margin-bottom: 0;
					}
					.radio-container {
						margin: 0 8px;
						.label-container {
							font-size: 14px;
						}
					}
				}
			}
		}
		.total-summary {
			padding: 0 15px 20px;
		}
		.container-input-list {
			height: calc(100% - 349px);
			overflow: auto;
			@media (max-height: 700px) {
				overflow: unset;
				min-height: 205px;
				height: auto;
			}

			.input-product-cart:last-child {
				border-bottom: none;
			}
		}
		.row-summary {
			display: flex;
			justify-content: space-between;
			margin-bottom: 5px;
		}
		.total-container {
			padding: 15px 0;
			margin-top: 15px;
			border-top: 1px solid #d7d7d7;
			.total-content {
				display: flex;
				justify-content: space-between;
				p {
					font-weight: 700;
				}
			}
			.iva-content {
				display: flex;
				justify-content: flex-end;
				p, span {
					font-size: 12px;
					margin-right: 5px;
				}
			}
		}
		.align-payments-logo {
			display: flex;
			gap: 20px;
			margin-top: 20px;
			justify-content: space-around;
			@media(max-width: 520px) {
				gap: 10px;
			}
			img {
				max-width: 40px;
				max-height: 20px;
			}
		}
		.base-button {
			width: 100%;
		}
		.term-condition-style {
			margin-top: 10px;
			p {
				font-size: 12px;
				line-height: 18px;
			}

		}
	}
	&.active {
		visibility: visible;
		@media(max-width: 1440px) {
			background-color: rgb(0 0 0 / 50%);
		}
		.shop-cart {
			@media(max-width: 1440px) {
				transform: translateX(0);
				opacity: 1;
			}
		}
	}
}
</style>